<template>
  <div class="wrap-preview-button" :class="wClass">
    <div class="wrap-header">
      <label class="lbl">Preview {{ button.name }}</label>
    </div>
    <div class="wrap-body">
      <div class="wrap-box">
        <div class="wrap-btn-preview mb-3">
          <label class="lbl">Large</label>
          <ButtonPreviewItem
            :key="'large_' + button.value.icon"
            :title-button="titleButton(button)"
            :style-button="cssButtonLarge"
            :button="button"
            :type-button="BUTTON_TYPE_LARGE"
            @on-hover-button="onHandleButton(BUTTON_TYPE_LARGE, true)"
            @on-leave-button="onHandleButton(BUTTON_TYPE_LARGE, false)" />
        </div>
        <div class="wrap-btn-preview mb-3">
          <label class="lbl">Medium</label>
          <ButtonPreviewItem
            :key="'medium_' + button.value.icon"
            :title-button="titleButton(button)"
            :style-button="cssButtonMedium"
            :button="button"
            :type-button="BUTTON_TYPE_MEDIUM"
            @on-hover-button="onHandleButton(BUTTON_TYPE_MEDIUM, true)"
            @on-leave-button="onHandleButton(BUTTON_TYPE_MEDIUM, false)" />
        </div>
        <div class="wrap-btn-preview mb-3">
          <label class="lbl">Small</label>
          <ButtonPreviewItem
            :key="'small_' + button.value.icon"
            :title-button="titleButton(button)"
            :style-button="cssButtonSmall"
            :button="button"
            :type-button="BUTTON_TYPE_SMALL"
            @on-hover-button="onHandleButton(BUTTON_TYPE_SMALL, true)"
            @on-leave-button="onHandleButton(BUTTON_TYPE_SMALL, false)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ButtonMixin from '../../utils/mixins/Button';
import { mapState } from 'vuex';
import ButtonPreviewItem from './/ButtonPreviewItem.vue';
import { BUTTON_TYPE_LARGE, BUTTON_TYPE_MEDIUM, BUTTON_TYPE_SMALL } from '@modules/editor-sidebar';

export default defineComponent({
  name: 'ButtonPreview',
  components: {
    ButtonPreviewItem,
  },
  mixins: [ButtonMixin],
  props: {
    button: {
      type: Object,
      default: () => ({}),
    },
    wClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isHoverButtonLarge: false,
    isHoverButtonMedium: false,
    isHoverButtonSmall: false,
    BUTTON_TYPE_LARGE,
    BUTTON_TYPE_MEDIUM,
    BUTTON_TYPE_SMALL,
  }),
  computed: {
    ...mapState('sidebar', {
      currentPreset: (state: any) => state.currentPreset,
    }),
    cssButtonGeneral() {
      return this.convertButtonOptionToCssObject(this.button as any);
    },
    cssButtonLarge() {
      return this.getCssButton('button-large', this.isHoverButtonLarge);
    },
    cssButtonMedium() {
      return this.getCssButton('button-medium', this.isHoverButtonMedium);
    },
    cssButtonSmall() {
      return this.getCssButton('button-small', this.isHoverButtonSmall);
    },
  },
  methods: {
    onHandleButton(typeButton: string, isActive: boolean) {
      if (typeButton === BUTTON_TYPE_LARGE) {
        this.isHoverButtonLarge = isActive;
      }
      if (typeButton === BUTTON_TYPE_MEDIUM) {
        this.isHoverButtonMedium = isActive;
      }
      if (typeButton === BUTTON_TYPE_SMALL) {
        this.isHoverButtonSmall = isActive;
      }
      return;
    },
    getCssButton(type: string, isHover: boolean) {
      const obj: any = {};
      if (isHover) {
        obj.button = {
          ...this.cssButtonGeneral['button'],
          ...this.cssButtonGeneral['buttonHover'],
          ...this.cssButtonGeneral[type],
        };
        obj.icon = {
          ...this.cssButtonGeneral['icon'],
          ...this.cssButtonGeneral['iconHover'],
        };
      } else {
        obj.button = {
          ...this.cssButtonGeneral['button'],
          ...this.cssButtonGeneral[type],
        };
        obj.icon = {
          ...this.cssButtonGeneral['icon'],
        };
      }
      return obj;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wrap-preview-button {
  top: 0;
  position: absolute;
  left: 300px;
  background: map-get($hybrid-shade-light, '100');
  color: map-get($text-light-mode, 'high-contrast');
  @include boxshadow(
    0px 12px 38px rgba(34, 34, 34, 0.0393604),
    0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545),
    0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07),
    0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455),
    0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064),
    0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14)
  );
  border-radius: $radius;
  -moz-border-radius: $radius;
  -webkit-border-radius: $radius;
  @media screen and (max-width: 1300px) {
    left: 270px;
  }
  .wrap-header {
    background: map-get($hybrid-shade-dark, '400');
    white-space: nowrap;

    .lbl {
      color: map-get($text-dark-mode, 'high-contrast');
      padding: 12px;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
    }
  }

  .wrap-body {
    padding: 12px;
    height: inherit;
    background: map-get($hybrid-shade-dark, '200');

    .wrap-box {
      background: #f2e8f7;
      border-radius: $radius;
      -moz-border-radius: $radius;
      -webkit-border-radius: $radius;
      padding: 16px 12px;
    }
  }
}
</style>
